import PublicLayout from '../components/PublicLayout.jsx';
import Hero from '../components/Hero.jsx';
import ServicesSection from '../components/ServicesSection.jsx';
import PortfolioSection from '../components/PortfolioSection.jsx';
import TestimonialSection from '../components/TestimonialSection.jsx';
import ContactInfoSection from '../components/ContactInfoSection.jsx';

export default function Home() {
  return (
    <PublicLayout>
      <Hero />
      <ServicesSection />
      <PortfolioSection limit={9} />
      <TestimonialSection />
      <ContactInfoSection />
    </PublicLayout>
  );
}
